import * as Yup from "yup";
import { fileArraySchema } from "../common-pre-screen/common";
import moment from "moment";

// patientsNationalityOptions
export const PatientsNationalityOptions = [
  { value: "Indian", label: "Indian" },
  { value: "International", label: "International" },
];

//Primary Refractory Options
export const PrimaryRefractoryOptions = [
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

//Bulky Disease Options
export const BulkyDiseaseOptions = [
  { value: "1", label: "Yes ( >7 cm )" },
  { value: "0", label: "No ( <7 cm )" },
];

//Bulky Disease Options
export const primaryDiagnosisOptions = [
  { value: "1", label: "B-ALL" },
  { value: "2", label: "DLBCL" },
  { value: "3", label: "B-NHL" },
];
//Bulky Disease Options
export const primaryDiagnosisSubtypeOptions = [
  { value: "1", label: "GCB" },
  { value: "2", label: "ABC" },
];

//In Bound Form Status Options
export const InboundFormStatus = [
  { value: "0", label: "In progress" },
  { value: "1", label: "Draft" },
  { value: "2", label: "Submitted" },
  { value: "3", label: "Received" },
];


export const SUPPORTED_FORMATS = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
];

export const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB

// const fileArraySchema = Yup.array()
//   .of(
//     Yup.mixed()
//       .test("fileType", "Unsupported file format", (file) =>
//         file ? SUPPORTED_FORMATS.includes(file.file_type) : true
//       )
//       .test("fileSize", "File too large (max 25MB)", (file) =>
//         file ? file.file_size < MAX_FILE_SIZE : true
//       )
//   )
//   .nullable();

// LSM blood not used Case Options
export const BloodNotUsed = [
  { value: "blood_not_used", label: "LSM blood not used" }
];
export const SampleTypes = [
  { value: "fresh_lsm", label: "Fresh LSM" },
  { value: "cryo_lsm", label: "Cryo LSM" },
  { value: "blood_samples", label: "Blood Samples" },
];

export const ALCDelcarationOption = [{ value: 1, label: "I confirm the value entered is less than acceptable range of 2 × 10⁹ cells."}];

export const DispatchModes = [
  { value: "in_house", label: "In-house" },
  { value: "third_party", label: "Third-party" },
];

export const LogisticsPartners = [
  { value: "blue_dart", label: "Blue Dart" },
  { value: "ekart", label: "Ekart" },
  { value: "flaxfly", label: "Flax and fly" },
];

export const equipmentOptions = [
  { value: "equipment_1", label: "Equipment 1" },
  { value: "equipment_2", label: "Equipment 2" },
  { value: "equipment_3", label: "Equipment 3" },
  { value: "equipment_4", label: "Equipment 4" },
];

export const confirmationOptions1 = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

export const confirmationOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

// Validation Schema For Inbound Form Part A
export const InboundFormPartASchema = (isDraft) =>
  Yup.object().shape({
    patient_weight: Yup.number()
      .typeError("Patient weight must be a number")
      .min(0, "Patient weight cannot be less than 0")
      .max(200, "Patient weight cannot be more than 200")
      .when([], {
        is: () => isDraft,
        then: (schema) => schema.notRequired().nullable(),
        otherwise: (schema) => schema.required("Patient weight at leukapheresis is required"),
      }),

    sample_types: Yup.array()
      .of(
        Yup.string().min(1).when([], {
          is: () => isDraft,
          then: (schema) => schema.notRequired(),
          otherwise: (schema) => schema.required("Sample type is required")
        })
      )
      .when([], {
        is: () => isDraft,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.min(1, "At least one sample type must be selected").required("Sample types are required")
      }),

    lsm_bag_quantity: Yup.number()
      .typeError("LSM bag quantity must be a number")
      .when(["sample_types"], {
        is: (types) =>
          !isDraft && (types?.includes("fresh_lsm") || types?.includes("cryo_lsm")),
        then: (schema) =>
          schema.required("LSM bag Quantity is required").min(1),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    blood_tube_quantity: Yup.number()
      .typeError("Blood tube quantity must be a number")
      .when(["sample_types"], {
        is: (types) =>
          !isDraft && types?.includes("blood_samples"),
        then: (schema) =>
          schema.required("Blood tube quantity is required").min(1),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    lsm_volumes: Yup.array()
      .of(
        Yup.object().shape({
          bag_no: Yup.string().when("blood_not_used", {
            is: (val) => val?.includes("blood_not_used"), // checkbox checked
            then: (schema) => schema.notRequired().nullable(),  // No validation
            otherwise: (schema) =>
              isDraft ? schema.notRequired() : schema.required("Bag No. is required"),
          }),

          volume: Yup.number()
            .typeError("Volume must be a number")
            .when("blood_not_used", {
              is: (val) => val?.includes("blood_not_used"), // checkbox checked
              then: (schema) => schema.notRequired().nullable(), // Skip validation
              otherwise: (schema) =>
                isDraft
                  ? schema.notRequired().nullable()
                  : schema
                    .required("Volume is required")
                    .moreThan(0, "Volume must be greater than 0"),
            }),

        })
      )
      .when([], {
        is: () => isDraft,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema.min(1, "At least one LSM volume entry is required"),
      }),

    collection_date: Yup.string().when([], {
      is: () => isDraft,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required("Collection date is required"),
    }),

    start_time: Yup.string().when([], {
      is: () => isDraft,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required("Start time is required"),
    }),

    stop_time: Yup.string().when([], {
      is: () => isDraft,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required("Stop time is required").test("is-after-start", "Stop time must be after start time", function (value) {
          const { start_time } = this.parent;
          if (!start_time || !value) return true;
          const [startHour, startMin] = start_time.split(":").map(Number);
          const [stopHour, stopMin] = value.split(":").map(Number);
          return stopHour * 60 + stopMin > startHour * 60 + startMin;
        }),
    }),

    mode_of_dispatch: Yup.string().when([], {
      is: () => isDraft,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required("Mode of dispatch is required"),
    }),

    logistics_partner: Yup.string().when(["mode_of_dispatch"], {
      is: (val) => !isDraft && val === "third_party",
      then: (schema) => schema.required("Logistics partner is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    date_of_dispatch: Yup.string().when([], {
    is: () => isDraft,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .required("Date of dispatch is required")
        .test(
          "not-before-collection",
          "Dispatch date cannot be before collection date",
          function (dispatch_Date) {
            const { collection_date } = this.parent;

            if (!collection_date || !dispatch_Date) {
              return true; // wait until both values exist
            }
           const dispatchDate =  moment(dispatch_Date,'DD/MM/YYYY').format('DD/MM/YYYY')
           const collectionDate =  moment(collection_date).format('DD/MM/YYYY')
            // dispatch >= collection_date
            return dispatchDate >= collectionDate;
          }
        ),
     }),
    temperature_at_dispatch: Yup.number()
      .typeError("Temperature at dispatch must be a number")
      .when([], {
        is: () => isDraft,
        then: (s) => s.notRequired().nullable(),
        otherwise: (s) =>
          s.required("Temperature at dispatch is required")
            .min(-100)
            .max(100)
            .test("max-2-decimals", "Temperature at dispatch can have at most 2 decimal places", (value) =>
              value == null || /^-?\d+(\.\d{1,2})?$/.test(value?.toString())
            ),
      }),
      time_of_dispatch: Yup.string().when([], {
        is: () => isDraft,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema
            .required("Time of dispatch is required")
            .test(
              "is-after-collection-time",
              "Dispatch date & time must be after collection date & time",
              function (dispatchTime) {
                const { collection_date, stop_time, date_of_dispatch } = this.parent;

                if (!collection_date || !stop_time || !dispatchTime || !date_of_dispatch) {
                  return true; // skip validation until all values exist
                }
                 const dispatchDate =  moment(date_of_dispatch,'DD/MM/YYYY').format('DD/MM/YYYY')
                 const collectionDate =  moment(collection_date).format('DD/MM/YYYY')
          
                if(dispatchDate > collectionDate)
                return true; 
                // Parse collection datetime
                const collectionDateTime = moment(collection_date); // handles JS Date string
                collectionDateTime.set({
                  hour: Number(stop_time.split(":")[0]),
                  minute: Number(stop_time.split(":")[1]),
                  second: 0,
                  millisecond: 0,
                });

                // Parse dispatch datetime
                const dispatchDateTime = moment(date_of_dispatch, "DD/MM/YYYY"); // if dispatch date is DD/MM/YYYY
                dispatchDateTime.set({
                  hour: Number(dispatchTime.split(":")[0]),
                  minute: Number(dispatchTime.split(":")[1]),
                  second: 0,
                  millisecond: 0,
                });

                return dispatchDateTime.isAfter(collectionDateTime);
              }
            ),
      }),

    editor_name: Yup.string().when([], {
      is: () => isDraft,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required("Editor name is required"),
    }),

    alc: Yup.number()
      .typeError("ALC must be a number")
      .when([], {
        is: () => isDraft,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("ALC is required"),
      }),
    alc_declaration: Yup.array()
  .when("alc", {
    is: (val) => !!val && val < 2 && !isDraft,  // ALC has value + not draft
    then: (schema) =>
  schema.test(
    "min-items",
    "Declaration is required",
    (value) => {
      return (
        Array.isArray(value) &&
        value.length > 0 &&
        value.every((item) => item !== undefined && item !== null && item !== "")
      );
    }
  ),
    otherwise: (schema) => schema.notRequired(),
  })
   
  });


// Validation Schema For Inbound Form Part B
export const InboundFormPartBSchema = (isDraft) =>
  Yup.object().shape({
    // SECTION E
    date_of_receipt: Yup.string()
      .max(100, "Date of receipt must be at most 100 characters")
      .when([], {
        is: () => !isDraft,
        then: schema => schema.required("Date of receipt is required"),
        otherwise: schema => schema.notRequired(),
      }),

    temperature_at_receipt: Yup.number()
      .typeError("Temperature at receipt must be a number")
      .test(
        "max-2-decimals",
        "Temperature must have at most 2 decimal places",
        value =>
          value == null ||
          /^-?\d+(\.\d{1,2})?$/.test(value.toString())
      )
      .when([], {
        is: () => !isDraft,
        then: schema => schema.required("Temperature at receipt is required"),
        otherwise: schema => schema.notRequired().nullable(),
      }),

    time_of_receipt: Yup.string().when([], {
      is: () => !isDraft,
      then: schema => schema.required("Time of receipt is required"),
      otherwise: schema => schema.notRequired(),
    }),

    quantity_received: Yup.number()
      .max(5, "Value cannot be greater than 5")
      .nullable()
      .when([], {
        is: () => !isDraft,
        then: schema => schema.required("No. of Bags is required"),
        otherwise: schema => schema.notRequired(),
      }),

    leakage: Yup.boolean().when([], {
      is: () => !isDraft,
      then: schema => schema.required("Leakage check is required"),
      otherwise: schema => schema.notRequired(),
    }),

    leakage_comment: Yup.string().when(["leakage"], {
      is: (val) => val && !isDraft,
      then: Yup.string().required("Leakage's comment is required"),
      otherwise: Yup.string().notRequired(),
    }),

    seal_broken: Yup.boolean().when([], {
      is: () => !isDraft,
      then: schema => schema.required("Seal broken check is required"),
      otherwise: schema => schema.notRequired(),
    }),

    seal_broken_comment: Yup.string().when(["seal_broken"], {
      is: (val) => val && !isDraft,
      then: Yup.string().required("Seal broken's comment is required"),
      otherwise: Yup.string().notRequired(),
    }),

    transport_box_damaged: Yup.boolean().when([], {
      is: () => !isDraft,
      then: schema =>
        schema.required("Transport box damaged check is required"),
      otherwise: schema => schema.notRequired(),
    }),

    transport_box_damaged_comment: Yup.string().when(
      ["transport_box_damaged"],
      {
        is: (val) => val && !isDraft,
        then: Yup.string().required("Transport box damaged's comment is required"),
        otherwise: Yup.string().notRequired(),
      }
    ),

    receipt_photo: fileArraySchema.notRequired(),
    remarks: Yup.string().when([], {
      is: () => !isDraft,
      then: schema => schema.required("Remarks is required"),
      otherwise: schema => schema.notRequired(),
    }),
  });
export const InboundFormPartDSchema = (isDraft = false) =>
  Yup.object().shape({
    media_id: fileArraySchema.when([], {
      is: () => !isDraft,  // only required if not draft
      then: schema =>
        schema.min(1, "Data Logger file is required"), // ensures array is not empty
      otherwise: schema => schema.notRequired(),
    }),
  });

export const InboundFormPartCSchema = (isQaRemarks = false, isDraft = false) =>
  Yup.object().shape({
  temperature_excursion: Yup.string().when([], {
      is: () => !isDraft,
      then: schema =>
        schema.required("Temperature excursion check is required"),
      otherwise: schema => schema.notRequired(),
    }),

    excursion_time: Yup.string().when(["temperature_excursion"], {
      is: (val) => val === "true" && !isDraft,
      then: Yup.string().required("Excursion time is required"),
      otherwise: Yup.string().notRequired(),
    }),

    excursion_temp: Yup.number()
      .nullable()
      .test(
        "max-2-decimals",
        "Excursion temperature must have at most 2 decimal places",
        value =>
          value == null ||
          /^-?\d+(\.\d{1,2})?$/.test(value.toString())
      )
      .when(["temperature_excursion"], {
        is: (val) => val === "true" && !isDraft,
        then: Yup.number()
          .typeError("Excursion temperature must be a number")
          .required("Excursion temperature is required"),
        otherwise: Yup.number().nullable().notRequired(),
      }),

    temperature_excursion_comment: Yup.string().when(
      ["temperature_excursion"],
      {
        is: (val) => val === "true" && !isDraft,
        then: Yup.string().required("Excursion duration's comment is required"),
        otherwise: Yup.string().notRequired(),
      }
    ),

    excursion_duration: Yup.string().when(["temperature_excursion"], {
      is: (val) => val === "true" && !isDraft,
      then: Yup.string()
        .required("Excursion duration is required")
        .matches(
          /^(?:[01]\d|2[0-3])[:-][0-5]\d$/,
          "Excursion duration must be in HH:MM or HH-MM format (e.g., 22:33)"
        ),
      otherwise: Yup.string().notRequired(),
    }),
    // Acceptance Criteria
    criteria_met: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === "boolean") return originalValue ? 1 : 0;
        if (typeof originalValue === "string") return Number(originalValue);
        return value;
      })
      .typeError("Acceptance criteria must be a number")
      .when([], {
        is: () => !isDraft,
        then: (schema) => schema.required("Acceptance criteria is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    // Declaration to Proceed
    declaration_to_proceed: Yup.array()
      .nullable()
      .transform((value, originalValue) => {
        if (Array.isArray(originalValue)) return originalValue;
        return originalValue ? [originalValue] : null;
      })
      .when([], {
        is: () => !isDraft,
        then: (schema) =>
          schema
            .min(1, "Please add at least one character")
            .required("Comment is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    // QA Remarks (only when enabled)
    ...(isQaRemarks
      ? {
          qa_remarks: Yup.array()
            .nullable()
            .transform((value, originalValue) => {
              if (Array.isArray(originalValue)) return originalValue;
              return originalValue ? [originalValue] : null;
            })
            .when([], {
              is: () => !isDraft,
              then: (schema) =>
                schema
                  .min(1, "Please add at least one character")
                  .required("Remark is required"),
              otherwise: (schema) => schema.notRequired(),
            }),
        }
      : {}),
  });


export const clinicalStatus = [
  { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
  {
    lable: "Clinical Feasible",
    color: "success",
    bgColor: "#E4F9F2",
    text: "#00B278",
  },
  {
    lable: "Feasible with Conditions",
    color: "success",
    bgColor: "#E4F9F2",
    text: "#00B278",
  },
  {
    lable: "Not Feasible",
    color: "error",
    bgColor: "#FFE3E3",
    text: "#FF2023",
  },
];
export const financialStatus = [
  { lable: "Pending", color: "warning", bgColor: "#FFEDCB", text: "#FB9D2C" },
  {
    lable: "Financial Feasible",
    color: "success",
    bgColor: "#E4F9F2",
    text: "#00B278",
  },
  {
    lable: "Not Feasible",
    color: "error",
    bgColor: "#FFE3E3",
    text: "#FF2023",
  },
  {
    lable: "Special Approval",
    color: "success",
    bgColor: "#E4F9F2",
    text: "#00B278",
  },
  {
    lable: "Not Applicable",
    color: "warning",
    bgColor: "#FFEDCB",
    text: "#FB9D2C",
  },
];

export function transformDataWithFiles(data) {
  const transformedFiles = {};

  if (Array.isArray(data.files)) {
    data.files.forEach((file) => {
      if (file.file_key && file.media) {
        transformedFiles[file.file_key] = file.media;
      }
    });
  }

  const { ...rest } = data;

  return {
    ...rest,
    ...transformedFiles,
  };
}

export const returnPostData = (values) => {
  const result = Object.fromEntries(
    Object.entries(values).map(([key, value]) => {
      if (Array.isArray(value) && key != "treatment_history") {
        const ids = value
          .filter((obj) => obj && typeof obj === "object" && "id" in obj)
          .map((obj) => obj.id);
        return [key, ids];
      }
      return [key, value];
    })
  );
  return result;
};

export function getNestedValue(obj, path) {
  if (!path) return undefined;
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Returns format: YYYY-MM-DD
};
